module.exports = __webpack_public_path__ + "static/NotoSans-ExtraBold-7d73bb09f57d68c30cc66ff6c035a216.ttf";